import { useMutation } from '@tanstack/react-query';
import api from 'services/api';

const useDatasetValidate = () => {
  return useMutation({
    mutationFn: async ({ datasetId, configs }) => {
      try {
        const response = await api.post(`api/v1/datasets/${datasetId}/validate-configs`, JSON.stringify(configs));
        return response.data;
      }catch (error){
        return Promise.reject(error) ;
      }
    },
  });
};

export default useDatasetValidate;